import { render, staticRenderFns } from "./WorkPlaces.vue?vue&type=template&id=acc66eb4"
import script from "./WorkPlaces.vue?vue&type=script&lang=js"
export * from "./WorkPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports